import { DEMAND_TYPE } from '@demandproai/shared';
import { useTemplateContext } from '../context/TemplateContext';
import DemandTypeFilter from '../../../components/ui-control/DemandTypeFilter';
import TemplateListPagination from '../../../components/ui-control/TemplateListPagination';
import XModal from '../../../components/common/XModal';
import { XInput } from '../../../components';
import useDemandTypeNameForm from '../hooks/useDemandTypeNameForm';

const DemandTypeNameModal = () => {
    const { templateListData, setDemandTypeNameModalOpen } = useTemplateContext();
    const { formik, handleDemandBlur } = useDemandTypeNameForm();

    return (
        <XModal
            isOpen={true}
            title="Update Demand Type"
            onClose={() => setDemandTypeNameModalOpen(false)}
            size="lg"
        >
            <DemandTypeFilter />
            <div className="relative flex flex-col min-w-0 break-words bg-surface-alt border border-border rounded-md">
                <div className="flex-auto p-4">
                    <div className="overflow-x-auto">
                        <table className="dp-table">
                            <thead>
                                <tr>
                                    <th className="w-1/5">System Name</th>
                                    <th>Display Name</th>
                                    <th>Case Type</th>
                                    <th>State</th>
                                </tr>
                            </thead>
                            <tbody>
                                {templateListData?.map((item, i) => {
                                    const demand = DEMAND_TYPE[item?.demandType];
                                    if (!demand) return null;
                                    const fieldName = `demandNameMap.${item.state}__${item.caseType}__${demand.value}`;
                                    const key = `${item.state}__${item.caseType}__${demand.value}`;
                                    return (
                                        <tr key={demand.value || i}>
                                            <td>
                                                <label className="mb-0!">{demand.text}</label>
                                            </td>
                                            <td>
                                                <XInput
                                                    name={fieldName}
                                                    className="form-control"
                                                    placeholder={demand.text}
                                                    value={formik.values.demandNameMap?.[key] ?? ''}
                                                    onChange={formik.handleChange}
                                                    onBlur={handleDemandBlur({ item, demand })}
                                                />
                                            </td>
                                            <td>{item.caseType}</td>
                                            <td>{item.state}</td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <TemplateListPagination />
        </XModal>
    );
};

export default DemandTypeNameModal;
